module.exports = new __parcel__URL__("empty-add-card-darkmode.a582fc88.svg").toString();